import {Component, OnInit} from '@angular/core';
import {AuthState} from '../../store/auth/auth.reducer';
import {Store} from '@ngrx/store';
import {LoginCallBackAction} from '../../store/auth/auth.actions';

@Component({
  standalone: false,
  selector: 'auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
})
export class AuthCallbackComponent implements OnInit {

  constructor(private store: Store<{ authStateReducer: AuthState }>) { }

  ngOnInit() {
    this.store.dispatch(new LoginCallBackAction());
  }

}